export const buildTikTokEmbedUrl = (videoId: string): string =>
  `https://www.tiktok.com/player/v1/${videoId}?music_info=1&description=1&rel=0`;

export const buildTikTokEmbedThumbnailUrl = (videoId: string): string =>
  `https://www.tiktok.com/player/v1/${videoId}?controls=0&play_button=0&volume_control=0&fullscreen_button=0&music_info=0&description=0&timestamp=0&progress_bar=0&native_context_menu=0&closed_captions=0&rel=0&loop=0&autoplay=0`;
